export default __webpack_public_path__ + "static/media/youtube-music.0e29f137.svg";